import { SEARCH_BEGINS } from "../../constants";

const searchBegins = (data) => ({
    type: SEARCH_BEGINS,
    data
});

export const actionSearch = (params) => async (dispatch) => {
    dispatch(searchBegins(params))
}